import React from 'react'

export default (props) => 
    <svg {...props}  width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="22" height="22" rx="5" fill="#7DDE8B"/>
        <path d="M10.0077 5.89526L16.0077 10.9999L10.0077 16.1045" stroke="white" strokeWidth="2"/>
        <path d="M14.9999 11H4.00769" stroke="#FBFEFB" strokeWidth="2"/>
    </svg>
